(function () {
  'use strict';
  var product = document.querySelector('.sano-product-buybox');
  if (!product || window.__sanoPhotoIntroStarted) return;
  window.__sanoPhotoIntroStarted = true;
  var signup = document.querySelector('[data-bf-signup]');
  var claimAccess = !!(signup && window.Shopify && Shopify.theme && Number(Shopify.theme.id) === 207711961425 && Shopify.theme.role === 'unpublished');
  if (claimAccess) {
    product.classList.add('sano-claim-access');
    var emphasisTimer;
    function dismissClaim() {
      clearTimeout(emphasisTimer);
      signup.querySelector('.sano-bf-signup__shell').classList.remove('is-claim-highlight');
      var prompt = signup.querySelector('[data-claim-prompt]');
      if (prompt) prompt.hidden = true;
      var input = signup.querySelector('input[type="tel"]');
      if (document.activeElement === input) input.blur();
      // Stop only the claim navigation; never alter another drawer's scroll lock.
      window.scrollTo({top:window.scrollY,left:window.scrollX,behavior:'instant'});
    }
    signup.addEventListener('keydown',function(event){if(event.key==='Escape'){dismissClaim();if(label)label.closest('button').focus({preventScroll:true});}});
    signup.addEventListener('pointerdown',function(event){if(!event.target.closest('[data-bf-signup-form]'))dismissClaim();});
    function claim(event) {
      event.preventDefault(); event.stopImmediatePropagation();
      var input = signup.querySelector('input[type="tel"]');
      var shell = signup.querySelector('.sano-bf-signup__shell');
      var prompt = signup.querySelector('[data-claim-prompt]');
      if (!prompt) {
        prompt = document.createElement('div'); prompt.className = 'sano-claim-prompt'; prompt.dataset.claimPrompt = '';
        prompt.setAttribute('role', 'status');
        var heading = document.createElement('strong'); heading.className = 'sano-claim-prompt__title'; heading.textContent = 'Claim jouw toegang';
        var copy = document.createElement('span'); copy.className = 'sano-claim-prompt__copy'; copy.textContent = 'Mis de start en je kans op de Gouden Ticket-prijzen niet. Ontvang de startmelding.';
        var close = document.createElement('button'); close.type = 'button'; close.className = 'sano-claim-prompt__close'; close.setAttribute('aria-label','Melding sluiten en verder bekijken'); close.textContent = 'Sluiten'; close.addEventListener('click',dismissClaim);
        prompt.append(heading, copy, close);
        signup.querySelector('[data-bf-signup-form]').prepend(prompt);
      }
      prompt.hidden = false;
      shell.classList.remove('is-claim-highlight'); void shell.offsetWidth; shell.classList.add('is-claim-highlight');
      clearTimeout(emphasisTimer); emphasisTimer = setTimeout(function(){shell.classList.remove('is-claim-highlight');},2600);
      prompt.scrollIntoView({behavior:'instant',block:'center'});
    }
    window.addEventListener('click',function(event){
      var button = event.target.closest('.sano-product-buybox .btn--add-to-cart,[data-sano-sticky-submit]');
      if (button) claim(event);
    },true);
    window.addEventListener('submit',function(event){if(product.contains(event.target)&&event.target.matches('form[action*="/cart/add"]'))claim(event);},true);
  }
  // Keep the scoped CTA label after native variant changes; leave unavailable states alone.
  var label = product.querySelector('.product-single__buttons .btn--add-to-cart .btn__text');
  if (label) {
    function syncLabel() { if (claimAccess && label.textContent !== 'Claim jouw toegang!') label.textContent = 'Claim jouw toegang!'; else if (!claimAccess && label.textContent.trim().toLowerCase() === 'winkelwagen') label.textContent = 'In winkelwagen'; }
    syncLabel();
    new MutationObserver(syncLabel).observe(label, { childList: true, characterData: true, subtree: true });
  }
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduced.matches || document.visibilityState === 'hidden') return;
  var gallery = product.querySelector('[data-sano-variant-gallery]');
  var host = gallery || product.querySelector('.product-single__main-media');
  if (!host) return;
  var img = gallery ? gallery.querySelector('.slick-current img, img.mfp-image') : host.querySelector('.slick-current img, img.mfp-image');
  if (!img) return;
  var finished = false, overlay, endTimer, loadTimer;
  function finish() {
    if (finished) return;
    finished = true;
    window.clearTimeout(endTimer); window.clearTimeout(loadTimer);
    img.removeEventListener('load', start); img.removeEventListener('error', finish);
    img.classList.remove('sano-photo-intro-image');
    product.removeEventListener('pointerdown', finish, true);
    product.removeEventListener('change', finish, true);
    product.removeEventListener('keydown', finish, true);
    document.removeEventListener('visibilitychange', visibility);
    window.removeEventListener('pagehide', finish);
    if (reduced.removeEventListener) reduced.removeEventListener('change', finish);
    if (overlay) overlay.remove();
    host.classList.remove('sano-photo-intro-host');
  }
  function visibility() { if (document.visibilityState === 'hidden') finish(); }
  function start() {
    if (finished || overlay || !img.naturalWidth) return;
    window.clearTimeout(loadTimer);
    var rect = host.getBoundingClientRect();
    if (rect.bottom <= 0 || rect.top >= window.innerHeight) { finish(); return; }
    overlay = document.createElement('div');
    overlay.className = 'sano-photo-intro';
    overlay.setAttribute('aria-hidden', 'true');
    host.classList.add('sano-photo-intro-host');
    img.classList.add('sano-photo-intro-image');
    host.appendChild(overlay);
    endTimer = window.setTimeout(finish, 3000);
  }
  product.addEventListener('pointerdown', finish, true);
  product.addEventListener('change', finish, true);
  product.addEventListener('keydown', finish, true);
  document.addEventListener('visibilitychange', visibility);
  window.addEventListener('pagehide', finish, { once: true });
  if (reduced.addEventListener) reduced.addEventListener('change', finish);
  if (img.complete) { if (img.naturalWidth) start(); else finish(); }
  else { img.addEventListener('load', start, { once: true }); img.addEventListener('error', finish, { once: true }); loadTimer = window.setTimeout(finish, 1800); }
})();
